import axios from 'axios'

export default {
	getAll(searchParams) {
		return axios.get(window.dtServerUrl + '/numberports', {
			params: searchParams
		})
	},

	count(searchParams) {
		return axios.get(window.dtServerUrl + '/numberports/count', {
			params: searchParams
		})
	},

	getById(id) {
		return axios.get(window.dtServerUrl + '/numberports/' + id)
	},

	create(portingRequest) {
		return axios.post(window.dtServerUrl + '/numberports', portingRequest).then((response) => {
			return response?.data
		})
	},

	uploadLoa(portingRequestId, formData) {
		return axios
			.post(window.dtServerUrl + '/numberports/' + portingRequestId + '/loa', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then((response) => {
				return response?.data
			})
	},

	getLoa(portingRequestId) {
		return axios
			.get(window.dtServerUrl + '/numberports/' + portingRequestId + '/loa', {
				responseType: 'blob'
			})
			.then((response) => {
				return response?.data
			})
	},

	update(portingRequest) {
		return axios.put(window.dtServerUrl + '/numberports/' + portingRequest.id, portingRequest).then((response) => {
			return response?.data
		})
	},

	resellerUpdate(portingRequest) {
		return axios
			.put(window.dtServerUrl + '/numberports/' + portingRequest.id + '/resellerupdate', portingRequest)
			.then((response) => {
				return response?.data
			})
	},

	delete(id) {
		return axios.delete(window.dtServerUrl + '/numberports/' + id)
	},

	numberLookup(number) {
		return axios.get(window.dtServerUrl + '/numberports/numberlookup', {
			params: {
				number: number
			}
		})
	},

	statusUpdate(payload) {
		return axios.post(window.dtServerUrl + '/numberports/' + payload.id + '/statusupdate', {
			comments: payload.comments
		})
	}
}
